var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Text, Divider, Box } from 'wix-style-react';
import Comments from '../DocParts/Comments';
import Status from '../InvoiceViewV2/Status';
import AscendLogo from '../AscendLogo';
import { translate } from 'react-i18next';
import { InvoiceStatus, } from '@wix/ambassador-wix-quotes-web/types';
import { isStatusDisplayed } from '../InvoiceViewV2/Status/status-utils';
import { mapLineItemDtoToViewModelMapper } from './LineItems/mapLineItemDtoToViewModel.mapper';
import InvoiceInfo from './InvoiceInfo/InvoiceInfo';
import { Customer } from './Customer/Customer';
import { InvoiceBusinessInfo } from './InvoicesBusinessInfo/InvoicesBusinessInfo';
import LineItems from './LineItems/LineItems';
import Totals from './Totals/Totals';
import RecurringInvoiceView from '../RecurringInvoicesView/RecurringInvoicesView';
import { Logo } from './Logo/Logo';
var Title = function (_a) {
    var invoice = _a.invoice;
    return (React.createElement(Text, { weight: "normal", size: "medium", dataHook: "invoice-title" }, invoice.title));
};
var HideOnPrint = function (_a) {
    var children = _a.children;
    return (React.createElement(Box, { className: "hide-on-print" },
        React.createElement("style", null, "@media print {.hide-on-print{display: none;}}"),
        children));
};
var statusBadgeStyle = function (status) {
    return isStatusDisplayed({ status: status, isUoU: true })
        ? {
            marginTop: '-12px',
            transform: 'translateY(12px)',
            paddingLeft: '5%',
        }
        : {};
};
var MobileInvoiceView = function (_a) {
    var _b, _c;
    var invoice = _a.invoice, businessInfo = _a.businessInfo, _d = _a.status, status = _d === void 0 ? InvoiceStatus.Draft : _d, _e = _a.recurringInvoiceViewEnabled, recurringInvoiceViewEnabled = _e === void 0 ? false : _e, ascend = _a.ascend, t = _a.t, onInvoiceReady = _a.onInvoiceReady, businessCustomFields = _a.businessCustomFields, documentCustomFields = _a.documentCustomFields, footer = _a.footer, customInvoiceNumberLabel = _a.customInvoiceNumberLabel, customFields = _a.customFields, primarySiteLocale = _a.primarySiteLocale, showTaxPerLineItem = _a.showTaxPerLineItem, showTaxBreakdown = _a.showTaxBreakdown, newSubdivisionFormatEnabled = _a.newSubdivisionFormatEnabled;
    return (React.createElement(Box, { maxWidth: "600px", direction: "vertical" },
        recurringInvoiceViewEnabled && (React.createElement(RecurringInvoiceView, { recurringStandaloneViewEnabled: false, newMobileView: true, invoice: invoice, darkView: false, isReady: true })),
        React.createElement(HideOnPrint, null,
            React.createElement(Box, __assign({}, statusBadgeStyle(status)),
                React.createElement(Status, { status: status, isUoU: true }))),
        React.createElement(Box, { borderRadius: "8x", backgroundColor: "white", direction: "vertical", paddingLeft: "5%", paddingRight: "5%" },
            React.createElement(Box, { paddingTop: "23px", paddingBottom: "12px", direction: "vertical" },
                React.createElement(InvoiceInfo, { documentCustomFields: documentCustomFields, invoice: invoice, isRecurring: recurringInvoiceViewEnabled, status: status, customInvoiceNumberLabel: customInvoiceNumberLabel, customFields: customFields, primarySiteLocale: primarySiteLocale }),
                React.createElement(Logo, { logo: businessInfo.logo, onImageReady: onInvoiceReady }),
                React.createElement(Box, { paddingTop: "12px", paddingBottom: "18px" },
                    React.createElement(InvoiceBusinessInfo, { businessInfo: businessInfo, businessCustomFields: businessCustomFields })),
                React.createElement(Divider, null),
                React.createElement(Customer, { customer: invoice.customer, newSubdivisionFormatEnabled: newSubdivisionFormatEnabled }),
                React.createElement(Box, { paddingBottom: "21px" },
                    React.createElement(Divider, null)),
                React.createElement(Title, { invoice: invoice })),
            React.createElement(LineItems, { lineItems: mapLineItemDtoToViewModelMapper((_c = (_b = invoice.lineItems) === null || _b === void 0 ? void 0 : _b.lineItems) !== null && _c !== void 0 ? _c : []), currencyCode: invoice.currencyCode, locale: invoice.locale && invoice.locale.language, showTaxPerLineItem: showTaxPerLineItem }),
            React.createElement(Box, { paddingBottom: "24px", width: "100%" },
                React.createElement(Totals, { invoice: invoice, showTaxBreakdown: showTaxBreakdown })),
            React.createElement(Box, null,
                React.createElement(Comments, { metaData: invoice.metaData, footer: {
                        firstLabel: footer === null || footer === void 0 ? void 0 : footer.notesLabel,
                        secondLabel: footer === null || footer === void 0 ? void 0 : footer.legalTermsLabel,
                    }, newMobileView: true })),
            ascend && (React.createElement(Box, { dataHook: "ascend-footer", direction: "horizontal", verticalAlign: "middle", paddingBottom: "33px" },
                React.createElement(Text, { weight: "normal", size: "tiny", secondary: true, light: true }, t('invoice-view:price-quote.created-with')),
                React.createElement(Box, { paddingLeft: "4px", display: "block" },
                    React.createElement(AscendLogo, null)))))));
};
export var MobileInvoicePreview = translate(['invoice-view', 'locale-data'], {
    wait: true,
})(MobileInvoiceView);
//# sourceMappingURL=MobileInvoiceView.js.map